import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_DOMAIN_BIDDER } from './api/query'
import { Data, Variables } from './api/types'
import { DomainBidderSlice, Props, UseGetDomainBidder } from './types'

export const useGetDomainBidder = ({ id }: Props): UseGetDomainBidder => {
  const [domainBidder, setDomainBidder] = useState<DomainBidderSlice>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const { node: domainBidder } = data

      if (domainBidder) {
        setDomainBidder(fromDTO(domainBidder))
      }
    },
    options: { enabled: !!id },
    query: GET_DOMAIN_BIDDER,
    variables: { id },
  })

  return { domainBidder, loading }
}
